import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../shared/services/authentication.service';
import {RegionService} from '../user-dashboard/shared/region.service';
import {Region} from '../user-dashboard/shared/region.model';

@Component({
  selector: 'app-decarbonization-screen',
  templateUrl: './decarbonization-screen.component.html',
  styleUrls: ['./decarbonization-screen.component.scss']
})
export class DecarbonizationScreenComponent implements OnInit {

  public regions: Array<Region>;

  constructor(
    private authService: AuthenticationService,
    private regionService: RegionService
  ) {
  }

  public ngOnInit(): void {
    this.regionService.getOwnRegions().subscribe(regions => this.regions = regions);
  }

  public canCreateDecarbonizationTypes() {
    return this.authService.canCreateDecarbonizationTypes();
  }

  public canManageRegionDecarbonizationTypes() {
    return this.authService.canManageRegionDecarbonizationTypes();
  }
}
